import React from 'react';
import { View } from 'react-native';
import { Colors } from '@banhala/ui-kit';

export const BlurBackground: React.FC = () => {
  return (
    <View
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        backdropFilter: 'blur(10px)',
        width: '100%',
        height: '100%',
      }}
    >
      <View
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: Colors.bg_black_button,
          opacity: 0.6,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      ></View>
    </View>
  );
};
